export default __webpack_public_path__ + "static/media/Playground- Kids.08fb8358.jpg";